import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import { Attachment, ColorProps, Tag } from '../../../../../@types';
import {
  FormControlLabel,
  FormControlLabelPlacementProps,
} from '../../../../../components/atoms/FormControlLabel';
import { SelectMenu } from '../../../../../components/atoms/SelectMenu';
import { Switch } from '../../../../../components/atoms/Switch';
import { AutocompleteTagType, Tags } from '../../../../../components/organisms/Tags';
import { getAttachmentTypes } from '../../../../../utils/report';
import { SECTION_HEADING_SX } from '../ReportEditFragment/reportEditDialog.styles';

const STATUS_ROW_SX = {
  m: 0,
  width: '100%',
  justifyContent: 'space-between',
  border: '1px solid',
  borderColor: 'v4.border',
  borderRadius: 1,
  px: 1.5,
  py: 1,
  bgcolor: 'v4.tableEven',
} as const;

export interface ScheduleEmailDeliveryFieldsProps {
  isActive: boolean;
  onChangeIsActive: (isActive: boolean) => void;
  attachmentTypes: Attachment[];
  /** Undefined until the attachment-types query resolves. */
  attachmentType?: number;
  onChangeAttachmentType: (attachmentTypeId: number) => void;
  selectedEmails: (AutocompleteTagType | string)[];
  onChangeSelectedEmails: (emails: (AutocompleteTagType | string)[]) => void;
  newEmails: Tag[];
  onChangeNewEmails: (emails: Tag[]) => void;
}

export const ScheduleEmailDeliveryFields: React.FC<ScheduleEmailDeliveryFieldsProps> = ({
  isActive,
  onChangeIsActive,
  attachmentTypes,
  attachmentType,
  onChangeAttachmentType,
  selectedEmails,
  onChangeSelectedEmails,
  newEmails,
  onChangeNewEmails,
}) => (
  <Box component="section">
    <Typography sx={SECTION_HEADING_SX}>Delivery</Typography>
    <Stack spacing={1.75} sx={{ mt: 1 }}>
      {/* The label wrapper makes the whole row clickable and gives the switch a
          real accessible name — the previous bare text node gave it neither. */}
      <FormControlLabel
        labelPlacement={FormControlLabelPlacementProps.Start}
        sx={STATUS_ROW_SX}
        control={
          <Switch
            color={ColorProps.Primary}
            checked={isActive}
            ariaLabel="Email schedule active"
            onChange={(event) => onChangeIsActive(event.target.checked)}
          />
        }
        label={
          <Box>
            <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>
              Email schedule active
            </Typography>
            <Typography variant="caption" sx={{ color: 'v4.textMuted' }}>
              Recipients receive this report on the schedule below.
            </Typography>
          </Box>
        }
      />

      <SelectMenu
        id="email-attachment-type-menu"
        label="Attachment Type *"
        required
        selectedValue={attachmentType || '-1'}
        // SelectMenu emits the option's string value; the wire field is a number.
        onChange={(value: string) => onChangeAttachmentType(Number(value))}
        items={getAttachmentTypes(attachmentTypes || [])}
        optionalLabelEnabled
      />

      <Tags
        allTags={[]}
        selectedTags={selectedEmails}
        setSeletedTags={onChangeSelectedEmails}
        newTags={newEmails}
        setNewTags={onChangeNewEmails}
        label="Recipients *"
        placeHolder="Enter email address(es)"
      />
    </Stack>
  </Box>
);
